1
00:00:00,000 --> 00:00:01,952
When it comes to making important

2
00:00:01,952 --> 00:00:03,486
decisions, or executing a

3
00:00:03,486 --> 00:00:05,299
strategy, it's crucial to have
[image url="https://app.gerositus.com/tutorials/stakeholders-intro/01.webp" initial="scale(1) translate(0%, 15%)" final="scale(1.1) translate(0%, -6%)" duration="17s"]

4
00:00:05,299 --> 00:00:07,112
your supporters backing you as

5
00:00:07,112 --> 00:00:10,807
much as possible, while also
working to keep detractors at bay.

6
00:00:10,807 --> 00:00:12,689
The key to achieving this lies in

7
00:00:12,689 --> 00:00:14,502
visualizing the situation and

8
00:00:14,502 --> 00:00:16,803
comprehending the dynamics
involved.


9
00:00:18,203 --> 00:00:22,107
Imagine you are taking on the role
of CEO in a mid-sized enterprise.

10
00:00:22,107 --> 00:00:23,920
Your aim is to produce tangible

11
00:00:23,920 --> 00:00:25,803
results as quickly as possible,
[image remove=true]

12
00:00:25,803 --> 00:00:28,104
ideally within the first
three months.


13
00:00:28,104 --> 00:00:29,847
To succeed, it’s important to

14
00:00:29,847 --> 00:00:31,520
avoid creating unnecessary

15
00:00:31,520 --> 00:00:33,402
friction with key stakeholders
[unmask target="main"]

16
00:00:33,402 --> 00:00:35,912
both inside and outside the
organization.

17
00:00:35,912 --> 00:00:37,934
Additionally, you want to make the

18
00:00:37,934 --> 00:00:39,887
most of the support from those who

19
00:00:39,887 --> 00:00:42,118
are enthusiastic about your
arrival.

20
00:00:42,118 --> 00:00:44,140
This is you on the Gerositus radar.
[createStakeholder id="me" name="You" x=0 y=0]

21
00:00:44,140 --> 00:00:46,022
As we are watching the situation

22
00:00:46,022 --> 00:00:47,835
from your point of view, we will

23
00:00:47,835 --> 00:00:50,763
[updateStakeholder id="me" x=120 delay=1500]
position you here, just outside
the neutral zone.

24
00:00:52,163 --> 00:00:54,464
Here is John, the
chairman of the board.
[createStakeholder id="john" name="John (Chairman)" icon="faChessKing" x=0 y=0 delay=1000]

25
00:00:54,664 --> 00:00:56,558
He is a key stakeholder.

26
00:00:56,958 --> 00:00:58,644
He has a lot of power.

27
00:00:59,044 --> 00:01:00,799
You will make him big.
[updateStakeholder id="john" impact="high" delay=2000]

28
00:01:02,399 --> 00:01:04,001
Say that he is also very much

29
00:01:04,001 --> 00:01:07,209
involved in the company and wants
you to be successful.

30
00:01:07,209 --> 00:01:09,929
He's placing a lot of hope in your
appointment.

31
00:01:09,929 --> 00:01:11,741
He has spoken about you in a very

32
00:01:11,741 --> 00:01:15,018
positive terms to a number of
people inside the company.

33
00:01:15,018 --> 00:01:18,644
[updateStakeholder id="john" x=0 y=30 delay=2000]
We are going to position him here,
highly positively engaged.

34
00:01:20,044 --> 00:01:22,484
You also know each other since a
long time.

35
00:01:22,484 --> 00:01:24,367
You trust him doing a lot for you,

36
00:01:24,367 --> 00:01:26,946
his inclination will always in
your favour.

37
00:01:27,146 --> 00:01:28,344
He is green.

38
00:01:28,544 --> 00:01:32,378
[updateStakeholder id="john" trend="green"]
We have now introduced three
concepts of stakeholders analysis.

39
00:01:32,378 --> 00:01:33,982
The first one is the level of

40
00:01:33,982 --> 00:01:36,143
concrete engagement characterized

41
00:01:36,143 --> 00:01:39,978
by the position inside the radar
on the positive or negative zone.

42
00:01:39,978 --> 00:01:41,721
The closer to the center of the

43
00:01:41,721 --> 00:01:45,486
radar, the more intense the
stakeholders' active involvement.

44
00:01:46,886 --> 00:01:48,768
The second one is the importance

45
00:01:48,768 --> 00:01:51,139
of that stakeholders
versus the others.

46
00:01:51,139 --> 00:01:52,743
And the third element is the

47
00:01:52,743 --> 00:01:55,810
propension or the inclination of
each stakeholder.

48
00:01:55,810 --> 00:01:57,832
Obviously this last key requires a

49
00:01:57,832 --> 00:02:01,179
strong understanding of the
person, or the institution.

50
00:02:01,179 --> 00:02:04,413
[updateStakeholder id="john" trend="white" delay=2000]
You would keep a stakeholder white
if you can't read it.

51
00:02:04,413 --> 00:02:07,155
[updateStakeholder id="john" trend="green" delay=500]
Green, trusted, its inclination is
positive.

52
00:02:07,155 --> 00:02:09,193
[updateStakeholder id="john" trend="orange" delay=1000]
Yellow, to be watched, for example

53
00:02:09,193 --> 00:02:10,882

when new external events are

54
00:02:10,882 --> 00:02:14,678
potentially going to impact its
positioning towards your goal.

55
00:02:16,078 --> 00:02:17,484
[updateStakeholder id="john" trend="red" delay=500]
And red signals that the

56
00:02:17,484 --> 00:02:19,664
stakeholder's positioning is going

57
00:02:19,664 --> 00:02:21,562
to get more difficult, either by

58
00:02:21,562 --> 00:02:24,797
being less engaged, or by moving
into the hostile zone.

59
00:02:24,797 --> 00:02:26,906
The interesting aspect about using

60
00:02:26,906 --> 00:02:29,156
colors, is that it can be
quite subtle.

61
00:02:29,156 --> 00:02:31,195
You could have a green stakeholder

62
00:02:31,195 --> 00:02:33,023
[updateStakeholder id="john" trend="green" y=-30 delay=1000]
in the hostile zone: this would

63
00:02:33,023 --> 00:02:34,851
express that you have, through

64
00:02:34,851 --> 00:02:36,960
bonding, managed to establish some

65
00:02:36,960 --> 00:02:39,210
level of trust with that
stakeholder.

66
00:02:39,210 --> 00:02:41,389
Things might get better,
but not yet.
[updateStakeholder id="john" trend="green" y=30 delay=3000]

67
00:02:43,289 --> 00:02:45,399
Let's now see the
situation of Mary.

68
00:02:45,399 --> 00:02:47,297
[createStakeholder id="mary" name="Mary (VP Research)" x=0 y=0 icon="faSearchDollar"]
She's the VP of research, she has

69
00:02:47,297 --> 00:02:49,195
always supported the company in

70
00:02:49,195 --> 00:02:52,500
every possible way, doing
regularly the extra-mile's.

71
00:02:52,500 --> 00:02:54,257
But you know that she was one of

72
00:02:54,257 --> 00:02:55,804
she candidates for the CEO

73
00:02:55,804 --> 00:02:58,687
position and a kind of of trusted
advisor to John.

74
00:02:58,687 --> 00:03:00,445
Since you have taken the lead,

75
00:03:00,445 --> 00:03:02,132
she's been quite silent, not

76
00:03:02,132 --> 00:03:05,085
really taking position and not
acting either way.

77
00:03:05,085 --> 00:03:07,686
We are going to place her here for
the moment.
[updateStakeholder id="mary" x=-90 y=0 delay=2000]

78
00:03:09,086 --> 00:03:10,985
She seems to have taken a neutral

79
00:03:10,985 --> 00:03:12,953
stand, and we don't know about her

80
00:03:12,953 --> 00:03:15,063
concrete willingness to help after

81
00:03:15,063 --> 00:03:17,453
she has been turned down for the
top role.

82
00:03:17,453 --> 00:03:19,562
As she's an important stakeholder,

83
00:03:19,562 --> 00:03:21,320
we will increase her size a bit
[updateStakeholder id="mary" impact="medium" delay=1700]

84
00:03:21,320 --> 00:03:24,695
and yellow will be her color for
the moment, to be watched.
[updateStakeholder id="mary" trend="orange" delay=1000]

85
00:03:24,695 --> 00:03:26,242
We are also going to draw an

86
00:03:26,242 --> 00:03:29,617
influencing line from her to join,
a light one, but still.
[createStakeholderLink id="maryjohn" originId="mary" targetId="john" strength=1 delay=1500]

87
00:03:29,817 --> 00:03:31,441
Let's go to Jeremy.
[createStakeholder id="jeremy" name="Jeremy (MFT)" icon="faCogs" delay=1000]

88
00:03:33,241 --> 00:03:35,499
He is the VP of manufacturing.

89
00:03:35,699 --> 00:03:37,668
He's had issues with the previous

90
00:03:37,668 --> 00:03:40,480
CEO strategy and was one of its
main detractors.

91
00:03:40,480 --> 00:03:42,027
He's known for being a solo

92
00:03:42,027 --> 00:03:44,277
player, quite difficult
to work with.

93
00:03:44,277 --> 00:03:46,386
And production, frankly, is having

94
00:03:46,386 --> 00:03:49,831
quality problems, which doesn't
really help the company.

95
00:03:49,831 --> 00:03:51,659
There have been talks to let him

96
00:03:51,659 --> 00:03:54,190
go, but you wanted to give him a
last chance.

97
00:03:55,590 --> 00:03:59,176
Let's place him on the detractor
side, no influencing links.
[updateStakeholder id="jeremy" x=40 y=-45 delay=2000]

98
00:03:59,176 --> 00:04:02,340
Although you try to get him on
board, you failed so far.

99
00:04:02,540 --> 00:04:04,567
He seems stuck in the past.

100
00:04:04,767 --> 00:04:06,362
[updateStakeholder id="jeremy" trend="red" delay=900]
Red as a color and in terms of

101
00:04:06,362 --> 00:04:09,485
[updateStakeholder id="jeremy" impact="medium" delay=1000]
size, as important as his
management team peer, Mary.

102
00:04:09,485 --> 00:04:11,289
You know that she is the only one

103
00:04:11,289 --> 00:04:13,301
that he appreciates, to the extent

104
00:04:13,301 --> 00:04:15,452
that he would probably
listen to her.

105
00:04:17,052 --> 00:04:19,426
Let's draw a line from her to him.
[createStakeholderLink id="maryjeremy" originId="mary" targetId="jeremy" strength=1 delay=2000]

106
00:04:21,226 --> 00:04:22,836
Let's do a last one.

107
00:04:23,036 --> 00:04:24,771
This is Isabelle, and she's an
[createStakeholder id="isa" name="Isabelle (Union)" icon="faUsers" delay=300]

108
00:04:24,771 --> 00:04:27,269
influential member of the
workers' union.

109
00:04:27,269 --> 00:04:29,142
You know that the relations with

110
00:04:29,142 --> 00:04:30,669
the union are decent and no

111
00:04:30,669 --> 00:04:32,681
significant trouble so far, but in

112
00:04:32,681 --> 00:04:35,317
case things worsen, she can become
critical.

113
00:04:35,317 --> 00:04:37,260
As Isabelle is not engaging at the

114
00:04:37,260 --> 00:04:39,134
moment, neither positively nor

115
00:04:39,134 --> 00:04:41,146
negatively, we will keep Isabelle

116
00:04:41,146 --> 00:04:43,089
outside of the radar, so inactive
[updateStakeholder id="isa" y=-50 x=100 delay=1500]

117
00:04:43,089 --> 00:04:44,546
for the moment, but on the

118
00:04:44,546 --> 00:04:48,501
negative side as unions are known
to make things difficult for CEOs.

119
00:04:48,501 --> 00:04:51,762
And white as you haven't been able
to reach out to her yet.

120
00:04:53,162 --> 00:04:54,897
Let me now pause for a second to

121
00:04:54,897 --> 00:04:57,326
[unmask target="summary"]
show you a couple of additional
features.

122
00:04:57,326 --> 00:04:59,199
You see this gauge, it is built by

123
00:04:59,199 --> 00:05:00,864
an algorithm that takes into

124
00:05:00,864 --> 00:05:03,015
consideration the consolidation of

125
00:05:03,015 --> 00:05:04,958
all stakeholders' statuses, and

126
00:05:04,958 --> 00:05:06,832
therefore provides the  overall

127
00:05:06,832 --> 00:05:10,856
engagement level in your specific
situation at a given point in time.

128
00:05:10,856 --> 00:05:12,660
In other words, it allows you to

129
00:05:12,660 --> 00:05:14,742
have an immediate understanding of

130
00:05:14,742 --> 00:05:18,142
how favorable or on the contrary,
hostile your context is.

131
00:05:18,142 --> 00:05:19,946
The more hostile it is, the more

132
00:05:19,946 --> 00:05:21,681
difficult it will be for you to

133
00:05:21,681 --> 00:05:23,554
reach your goal as stakeholders

134
00:05:23,554 --> 00:05:25,913
[unmask target="sidemenu"]
will slow you down, or create
obstacles.

135
00:05:25,913 --> 00:05:27,717
When you select a stakeholder,

136
00:05:27,717 --> 00:05:29,383
[select type="Stakeholder" id="john"]
let's take John, you have the

137
00:05:29,383 --> 00:05:31,395
[click target="li.general"]
possibility under the general tab

138
00:05:31,395 --> 00:05:34,240
[hover target=".editStakeholder"]
[blur target=".editStakeholder" delay=100]
[hover target=".cloneStakeholder" delay=100]
[blur target=".cloneStakeholder" delay=1100]
[hover target=".deleteStakeholder" delay=1100]
[blur target=".deleteStakeholder" delay=2100]
to edit, duplicate, and delete the
stakeholder.

139
00:05:35,640 --> 00:05:37,374
You can also change the icon if

140
00:05:37,374 --> 00:05:39,456
[hover target=".IconPicker svg"]
[blur target=".IconPicker svg" delay=3000]
you want to visually differentiate

141
00:05:39,456 --> 00:05:42,301
stakeholders in the radar, for
example, by role.

142
00:05:42,301 --> 00:05:44,174
[click target="li.links" delay=2000]
By clicking on the links tab, you

143
00:05:44,174 --> 00:05:45,979
have the possibility to create

144
00:05:45,979 --> 00:05:47,921
[hover target=".createStakeholderLink"]
your links for that stakeholder,

145
00:05:47,921 --> 00:05:50,766
to delete existing links, and to
vary their size.

146
00:05:50,766 --> 00:05:52,640
Let's say that Mary, an incoming

147
00:05:52,640 --> 00:05:55,276
link, has actually a lot of
influence on John.

148
00:05:55,276 --> 00:05:58,052
We would increase the size of the
links this way.
[updateStakeholderLink id="maryjohn" strength=2 delay=1500]

149
00:05:58,052 --> 00:05:59,997
Tags is quite useful as well, for

150
00:05:59,997 --> 00:06:01,870
[click target="li.general"]
example if you want to indicate

151
00:06:01,870 --> 00:06:03,743
what drives each stakeholder,

152
00:06:03,743 --> 00:06:05,760
providing you with strategies to

153
00:06:05,760 --> 00:06:09,002
make them move more favorably, or
to neutralize them.

154
00:06:10,402 --> 00:06:13,644
You can also use tags to
categorize the stakeholders.

155
00:06:13,644 --> 00:06:15,445
For example, if you want to see

156
00:06:15,445 --> 00:06:17,174
only board members, you will

157
00:06:17,174 --> 00:06:21,064
create a tag called board and
assigns chosen stakeholders to it.

158
00:06:21,064 --> 00:06:23,514
But there are many other ways to
use tags.

159
00:06:23,514 --> 00:06:25,531
Another example is categorizing

160
00:06:25,531 --> 00:06:27,332
stakeholders by what they are

161
00:06:27,332 --> 00:06:29,205
bringing to you, information,

162
00:06:29,205 --> 00:06:31,583
execution power, feedback,
etcetera.

163
00:06:31,583 --> 00:06:34,896
Remember however the use the
different types of icons.

164
00:06:34,896 --> 00:06:37,562
The tab history is extremely
useful as well.
[click target="li.comments" delay=1000]

165
00:06:38,962 --> 00:06:40,547
It enables you to track the

166
00:06:40,547 --> 00:06:42,420
changes, to document events or

167
00:06:42,420 --> 00:06:46,166
meetings, basically to write the
story for each stakeholder.

168
00:06:46,166 --> 00:06:48,039
Last but not least, and this is a

169
00:06:48,039 --> 00:06:49,192
feature that makes

170
00:06:49,192 --> 00:06:53,298
Gerositus extremely powerful, is
the ability to create scenarios.
[deselect]
[unmask target="header"]

171
00:06:53,298 --> 00:06:55,748
Those scenarios can have
multiple uses.
[hover target=".createScenario"]

172
00:06:55,748 --> 00:06:57,693
For example, you could simulate

173
00:06:57,693 --> 00:06:59,710
the impact of terminating Jeremy

174
00:06:59,710 --> 00:07:01,511
on the other stakeholders and

175
00:07:01,511 --> 00:07:05,113
understand how your context might
evolve as a consequence.

176
00:07:05,313 --> 00:07:07,254
So let's do it together!
[blur target=".createScenario"]
[createScenario id="term" name="Terminating Jeremy" delay=1000]
[click target=".createScenario"]

177
00:07:07,454 --> 00:07:09,399
We will start with creating a new

178
00:07:09,399 --> 00:07:12,497
[click target=".ant-modal-close-x"]
scenario that would be called
terminating Jeremy.

179
00:07:12,497 --> 00:07:14,442
Now that we are in this scenario,

180
00:07:14,442 --> 00:07:17,540
we are ready to move
the stakeholders accordingly.

181
00:07:17,540 --> 00:07:19,413
So Jeremy, who is already in the

182
00:07:19,413 --> 00:07:21,502
hostile zone, may well become more

183
00:07:21,502 --> 00:07:24,168
actively negative, at
least, until he goes.
[updateStakeholder id="jeremy" y=-20 x=0 delay=1000]

184
00:07:24,168 --> 00:07:26,185
Now we also remember that Mary was

185
00:07:26,185 --> 00:07:27,554
quite uncertain in her

186
00:07:27,554 --> 00:07:31,300
positioning, and we also remember
that she was Jeremy's ally.

187
00:07:31,300 --> 00:07:34,037
So one hypothesis is that she
turns negative.

188
00:07:34,237 --> 00:07:36,178
[updateStakeholder id="mary" trend="red" y=-10 x=-90]
Not too much, but still.

189
00:07:36,378 --> 00:07:39,116
And maybe she would become yellow
or even red.

190
00:07:39,116 --> 00:07:40,989
And since Mary has significant

191
00:07:40,989 --> 00:07:44,735
influence on John, then he might
become a bit less supportive.
[updateStakeholder id="john" trend="white" y=60 delay=2000]

192
00:07:44,935 --> 00:07:46,660
What does this mean?

193
00:07:46,860 --> 00:07:48,877
It means that before terminating

194
00:07:48,877 --> 00:07:50,822
Jeremy, it is crucial to connect

195
00:07:50,822 --> 00:07:54,280
both with John and Mary and manage
the dynamics with them.

196
00:07:54,280 --> 00:07:56,225
If you don't, then you might have

197
00:07:56,225 --> 00:07:58,242
to face a quite negative context,

198
00:07:58,242 --> 00:08:01,268
putting at risk you ability to
achieve your goals.

199
00:08:01,268 --> 00:08:03,332
With no stakeholders selected, you

200
00:08:03,332 --> 00:08:05,190
have the possibility to search,

201
00:08:05,190 --> 00:08:08,698
which is quite useful when you
have a lot of them on your radar.

202
00:08:08,698 --> 00:08:11,450
You also have the possibility to
show all links.

203
00:08:11,450 --> 00:08:15,097
It can be overwhelming, and this
is why we made it just an option.

204
00:08:15,297 --> 00:08:16,898
And you can filter.

205
00:08:17,098 --> 00:08:19,024
For example, if you've added tags

206
00:08:19,024 --> 00:08:21,088
or other icons, then you
can filter.

207
00:08:21,088 --> 00:08:22,739
This way, you understand how

208
00:08:22,739 --> 00:08:24,253
favorable or hostile your

209
00:08:24,253 --> 00:08:28,037
alignment score is by category,
for example, the board category.

210
00:08:28,037 --> 00:08:29,894
As you can see, with just a couple

211
00:08:29,894 --> 00:08:31,752
of stakeholders on the radar and

212
00:08:31,752 --> 00:08:33,610
in a couple of minutes of work, we

213
00:08:33,610 --> 00:08:35,948
start seeing the story of the
situation.

214
00:08:35,948 --> 00:08:37,875
This snapshot gives you already a

215
00:08:37,875 --> 00:08:41,933
substantial competitive edge, an
insight that others might not have.

216
00:08:41,933 --> 00:08:43,517
On top of that, if you keep it

217
00:08:43,517 --> 00:08:45,581
dynamic by reviewing the situation

218
00:08:45,581 --> 00:08:47,370
regularly, for example, first

219
00:08:47,370 --> 00:08:49,227
thing each Monday morning, then

220
00:08:49,227 --> 00:08:51,016
you will see that the radar will

221
00:08:51,016 --> 00:08:53,906
start driving your actions in a
subconscious way.

222
00:08:53,906 --> 00:08:55,488
There are many other uses of

223
00:08:55,488 --> 00:08:59,547
scenarios that are explained in
details in Gerositus masterclasses.

224
00:09:00,947 --> 00:09:02,530
I hope that I've been able to

225
00:09:02,530 --> 00:09:04,387
explain the great benefits that

226
00:09:04,387 --> 00:09:07,139
you can derive out of a regular
use of Gerositus.

227
00:09:07,139 --> 00:09:08,859
If you are already a user, keep

228
00:09:08,859 --> 00:09:10,855
enjoying the journey and feel free

229
00:09:10,855 --> 00:09:13,263
to reach out for comments or
suggestions.

230
00:09:13,263 --> 00:09:14,776
If you are in a test period,

231
00:09:14,776 --> 00:09:18,216
please feel free to reach out if
you have further questions.

232
00:09:18,216 --> 00:09:19,523
For those of you who are

233
00:09:19,523 --> 00:09:21,175
interested in exploring the

234
00:09:21,175 --> 00:09:23,307
stakeholders theory more in-depth,

235
00:09:23,307 --> 00:09:24,959
go through a live case and see

236
00:09:24,959 --> 00:09:28,261
additional uses of all available
features in Gerosetus.

237
00:09:28,261 --> 00:09:30,050
Please do visit our website and

238
00:09:30,050 --> 00:09:32,802
feel free to register to an online
masterclass.

239
00:09:32,802 --> 00:09:34,453
I thank you very much for your

240
00:09:34,453 --> 00:09:37,205
attention and happy stakeholders
management!

